import { makeStyles } from '@mui/styles';
const darkGray = '#263238';
const lightGray = '#3f505a';
const ligherGray = '#cfd8dc';
const green = '#508b46';
export const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.spacing(1),
      boxShadow: 'none',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      background: '#f7f8f8',
      minHeight: '95px !important',
      padding: theme.spacing(0),
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
    },
    // Key Header
    titlePart: {
      marginInlineEnd: 'auto',
    },
    titleText: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'normal',
    },
    subtitleText: {
      fontSize: 12,
      color: '#546e7a',
      fontWeight: 'normal',
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
    },
    actionButtons: {
      marginTop: theme.spacing(2),
      marginInlineStart: theme.spacing(-0.5),
    },
    actionButton: {
      color: theme.palette.primary.main,
      paddingInlineStart: theme.spacing(2),
      paddingInlineEnd: theme.spacing(2),
    },
    balanceTitle: {
      marginTop: theme.spacing(2),
      fontSize: 12,
      color: darkGray,
      fontWeight: 'bold',
    },
    balanceMoney: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'normal',
      '& span': {
        fontSize: 14,
        color: lightGray,
        marginInlineStart: theme.spacing(0.5),
      },
    },
    titleActions: {
      marginInlineEnd: theme.spacing(-1),
      marginTop: theme.spacing(-0.5),
      minWidth: 350,
      [theme.breakpoints.down('lg')]: {
        minWidth: 'auto',
      },
    },
    titleActionsInside: {
      [theme.breakpoints.down('lg')]: {
        minWidth: 'auto',
        flexDirection: 'column !important',
        justifyContent: 'flex-start !important',
        alignItems: 'flex-start',
      },
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      color: '#7d8f9b',
      padding: theme.spacing(1),
      '&:hover': {
        color: theme.palette.primary.main,
      },
      [theme.breakpoints.down('lg')]: {
        marginInlineEnd: 'auto',
      },
    },
    propertyContainer: {
      marginTop: theme.spacing(3),
    },
    property: {
      fontSize: 14,
      color: lightGray,
      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,
      color: ligherGray,
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: green,
      },
    },
    otherActions: {
      marginLeft: 'auto !important',
      marginRight: 'o !important',
    },
    otherActionsMenu: {
      border: '1px solid #d8d1d1',
    },
    otherActionsMenuItem: {
      padding: theme.spacing(1.5),
      color: darkGray,
      minWidth: 160,
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    scopes: {
      marginTop: theme.spacing(3),
    },
    scopeItem: {
      display: 'inline-block',
      color: darkGray,
      fontSize: 12,
      fontFamily: 'Vazir',
      background: '#cfd8dc',
      fontWeight: '300',
      padding: `${theme.spacing(0.6)} ${theme.spacing(1.3)}`,
      lineHeight: 'initial',
      marginInlineEnd: 5,
      borderRadius: 3,
      marginTop: 5,
    },
    newGrant: {
      color: theme.palette.primary.main,
    },
    people: {
      color: '#37474f',
      marginInlineEnd: theme.spacing(2),
    },
    tableCell: {
      width: '20%',
      minWidth: '150px',
      padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
      borderBottom: '1px solid rgba(109,114,120,0.2)',
    },
    progress: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    table: {
      border: '1px solid rgba(109,114,120,0.18)',
      borderRadius: 4,
    },
    tableHeader: {
      background: '#eef1f5',
    },
    tableDataCell: {
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      fontFamily: 'Vazir',
    },
    newPermissionHint: {
      fontSize: 13,
      fontWeight: 'normal',
      color: '#1b3958',
      marginTop: theme.spacing(1),
    },
    form: {
      marginTop: theme.spacing(2),
    },
    

    customCaptchaDialog: {
      display: 'flex',
      flexDirection: 'row-reverse',
      gap: '15px',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    captchaDialog: {
      maxHeight: 37,
      maxWidth: '100%',
      borderRadius: 4,
      marginInlineStart: theme.spacing(1),
      marginTop: theme.spacing(3),
    },
    captchaLoadingDialog: {
      height: 68,
      width: 150,
      borderRadius: 4,
      marginInlineStart: theme.spacing(1),
      marginTop: 10,
    },
    captchaBoxDialog: {
      display: 'flex',
      alignItems: 'center',
    },
    iconActionCaptchaDialog: {
      marginTop: 12
    }



  };
});